export default {"src":"/_next/static/media/main-logo.7e72f9c9.svg","height":165,"width":520,"blurWidth":0,"blurHeight":0};